import { SimpleTeaser } from 'cpfr-common';
import { HeroImage } from '@cp-shared-19/frontend-ui';
import React, { useMemo } from 'react';
import { FaqUi } from '../ui';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { useMyProfile } from '../../my-profile';

type FaqPrivateProps = {
    faqTeaser?: SimpleTeaser;
};

export const FaqPrivate: React.FC<FaqPrivateProps> = ({ faqTeaser }) => {
    const { t } = useTranslation('faq-cms');
    const { data: myProfile } = useMyProfile();

    const customerType = useMemo(
        () => (myProfile?.identification?.customerType !== 'Retail' ? 'sme' : 'retail'),
        [myProfile],
    );

    const mappedFaqContentItems = useMemo(() => {
        const itemGroups: { category: string; items: { question: string; answer: string }[] }[] = t(
            `content.private.${customerType}.itemGroups`,
            {
                returnObjects: true,
                defaultValue: [],
            },
        );

        return itemGroups.map(({ category, items }) => ({
            header: category,
            items: items.filter((item) => !!item.question && !!item.answer),
        }));
    }, [t, customerType]);

    const descriptionText = t(`content.private.${customerType}.descriptionText`, '');

    return (
        <>
            {faqTeaser && (
                <>
                    <HeroImage
                        title={faqTeaser.title}
                        imageUrl={faqTeaser.imageUrl}
                        shallow={true}
                        inverted={faqTeaser.isInverted}
                        focalPoint="top-center"
                    />
                    <ContentSection pageWrapSize="medium">
                        <>
                            <h2>{t(`content.private.${customerType}.header`)}</h2>
                            {descriptionText && (
                                <div>
                                    <p>{descriptionText}</p>
                                </div>
                            )}
                        </>
                    </ContentSection>
                </>
            )}
            {mappedFaqContentItems.map((faqSection, idx) => (
                <FaqUi key={`FAQ-section-${idx}`} faqContent={faqSection} />
            ))}
        </>
    );
};
